/** @format */

const company = {
    file: '/assets/images/svg/company/File.svg',
    cancel_icon: '/assets/images/svg/company/cancel_icon.svg',
    math_icon: '/assets/images/svg/company/math.svg',
    focus_icon: '/assets/images/svg/company/focus.svg',
    exit_icon: '/assets/images/svg/company/exit.svg',
    arrow_top_right_icon: '/assets/images/svg/company/arrow_top_right.svg',
}

export default company
